export default {
  gray: {
    25: '#fcfdfe',
    50: '#f4f8fa',
    950: '#14151e'
  }
}
